import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../types/redux";

import Modal from "../Common/Modal";
import DisbursementHistoryTable from "./DisbursementHistoryTable";
import { SetBankAccountDisbursementHistory } from "../../actions/bankAccounts";

const DisbursementHistoryModal = () => {
  const dispatch = useDispatch();
  const { disbursementHistory } = useSelector((state: RootState) => state.bankAccounts);

  const handleClose = () => {
    dispatch(SetBankAccountDisbursementHistory({
      showDisbursementHistory: false,
      bankAccountName: "",
      bankAccountNumber: "",
      disbursementHistory: []
    }))
  }
  return (
    <Modal
      open={disbursementHistory.showDisbursementHistory}
      onClose={() => handleClose()}
      title="View History"
      content={<DisbursementHistoryTable />}
      actions={[]}
      className="table"
      large={true}
    />
  );
}

export default DisbursementHistoryModal;